import { mergeApplicationConfig } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { loadEgBrand } from '@expertgroup/shell/brand';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { provideProtaxBrand } from '@/app/core/brand/protax-brand';
import { initTelemetry } from '@/app/core/telemetry/otel';
import { environment } from '@/environments/environment';

// FIRST — register OpenTelemetry + patch the global fetch before Angular's HttpClient makes its first call,
// so every API request is traced and carries `traceparent`. No-op when no collector is configured.
initTelemetry();

// SECOND — maska hosta (shell 0.16): logotip, znak, favicon, ime organizacije i boje za host na kome je stranica, od
// KONFIGURISANOG issuer-a (`GET {issuer}/branding/by-host`). Posle initTelemetry(), pre bootstrap-a: šina se iscrta već
// sa maskom, bez bleska tuđeg ili generičkog izgleda. Nikad ne odbija i čeka najviše ~2 s — maska je izgled, ne uslov
// za rad; Identity koji ne odgovara znači generički izgled (ime proizvoda, bez logotipa).
//
// ⚠️ Zahtev ne ide kroz HttpClient (nema ni bearer-a ni interceptora) i mora ostati „prost" CORS GET. Zato issuer NIKAD
// ne ulazi u `propagateTraceHeaderCorsUrls` u otel.ts: `traceparent` bi tražio preflight koji endpoint ne očekuje, i
// aplikacija bi tiho ostala generička. Drži to `otel.spec.ts`.
loadEgBrand({ issuer: environment.issuer })
    .then((brand) => bootstrapApplication(App, mergeApplicationConfig(appConfig, { providers: [provideProtaxBrand(brand)] })))
    .catch((err) => console.error(err));
